import { useUserStore } from '@/stores/user.store';

export default defineNuxtRouteMiddleware(async () => {
  const user = useUserStore().user;
  const router = useRouter();
  if (!user && router.currentRoute.value.path !== '/index') {
    return navigateTo('/login');
  }
});
